/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class Metadata extends Fragment {
  @attr('string') declare goodFor: string;
}
